import React from 'react';
import ReportFrame from '../ReportFrame';

export default class AssignmentDetails extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const reportParams = {};
    return (
      <div className='contentwrapper bg-white'>
        <ReportFrame
          DynamicParams={['ClientId']}
          reportName='Assignment Details'
          reportParams={reportParams}
          id='assignmentdetailreport'
          name='assignmentdetailreport'
          title='Assignment Detail Report'
        />
      </div>
    );
  }
}
